var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import styled from "styled-components";
import forwardRef from "../../private/forwardRef";
import PropTypes from "prop-types";
import { paletteHelper } from "../../utils";
var Box = styled.div.withConfig({
  displayName: "Card__Box",
  componentId: "sc-g1378g-0"
})(["box-shadow:", ";border-radius:", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.shadow;
}, function (_ref2) {
  var theme = _ref2.theme,
    borderRadius = _ref2.borderRadius;
  return theme.border.radius[borderRadius];
}, paletteHelper("backgroundPrimaryLow"));
var defaultProps = {
  borderRadius: "large"
};

/**
 * The card component helps divide information into sections and to create visual hierarchy between elements.
 *
 * @see [Card documentation](https://construct-kit.reainternal.net/web/card)
 */
var Card = forwardRef(function (props, ref) {
  var _defaultProps$props = _extends({}, defaultProps, props),
    children = _defaultProps$props.children,
    rest = _objectWithoutPropertiesLoose(_defaultProps$props, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, rest), children);
});
Card.displayName = "Card";
Card.propTypes = {
  /** Controls the border-radius applied to the Card */
  borderRadius: PropTypes.oneOf(["small", "medium", "large"]),
  /** The nodes to be contained within the Card. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Card.defaultProps = defaultProps;
export default Card;